import LayoutContainer from 'components/Common/LayoutContainer'
import useRebrandVersion from 'hooks/useRebrandVersion'
import TextButton from 'LuxKit/Button/TextButton'
import Typography from 'LuxKit/Typography/Typography'
import Group from 'components/utils/Group'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'
import { rem } from 'polished'
import { useIntl } from 'react-intl'
import styled from 'styled-components'
import LoyaltyLandingPageBenefitsTable from './LoyaltyLandingPageBenefitsTable'
import Sheet from 'components/utils/Sheet'

const BenefitsTableScrollTarget = styled.div`
  scroll-margin-top: ${rem(80)};
`

interface Props {
  highlightTier?: App.LoyaltyTier
  onJoin?: () => void
  ctaLink?: string
  ctaText?: string
  compact?: boolean
  /** When set, the CTA only renders on mobile/tablet (hidden on desktop). */
  ctaMobileOnly?: boolean
}

function LoyaltyLandingPageBenefitsTableSection(props: Props) {
  const intl = useIntl()
  const defaultCtaText = intl.formatMessage({
    id: 'l3C4sGDjCxLM4vnEnR5n',
    defaultMessage: 'Join now - it’s free',
    description: 'Default call-to-action button text to join the free loyalty program',
  })
  const { highlightTier, onJoin, ctaLink, ctaText = defaultCtaText, compact, ctaMobileOnly } = props
  const isRebrand = useRebrandVersion() === 'rebrand'

  const showCta = onJoin || ctaLink

  const ctaButton = <Typography align="center">
    <TextButton
      kind="primary"
      onClick={onJoin}
      to={ctaLink}
    >
      {ctaText}
    </TextButton>
  </Typography>

  return <Sheet
    paletteType={isRebrand ? 'default' : 'inverse'}
    padding={compact ? '24 0 48 0' : '24 0'}
    tabletPadding="24 0 48 0"
    background={isRebrand ? 'light-background' : 'normal-background'}
  >
    <LayoutContainer variant="medium">
      <Group direction="vertical" gap={compact ? 12 : 48}>
        <BenefitsTableScrollTarget id="about-benefits">
          {isRebrand && <Sheet background="normal-background" borderRadius="M" padding={20} tabletPadding={32}>
            <LoyaltyLandingPageBenefitsTable highlightTier={highlightTier} />
          </Sheet>}
          {!isRebrand && <LoyaltyLandingPageBenefitsTable highlightTier={highlightTier} />}
        </BenefitsTableScrollTarget>
        {showCta && ctaMobileOnly && <CSSBreakpoint max="tablet">{ctaButton}</CSSBreakpoint>}
        {showCta && !ctaMobileOnly && ctaButton}
      </Group>
    </LayoutContainer>
  </Sheet>
}

export default LoyaltyLandingPageBenefitsTableSection
